var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{attrs:{"fixed-tabs":""}},[_c('v-tab',[_vm._v(" Fixed Tab 1 ")]),_c('v-tab',[_vm._v(" Fixed Tab 2 ")]),_c('v-tab',[_vm._v(" Fixed Tab 3 ")]),_c('v-tab',[_vm._v(" Fixed Tab 4 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }